<script lang="ts">
  import type { BlogListStoryblok } from "$types/components";
  import { blogFilter } from "$stores";
  import Section from "$lib/molecules/Section.svelte";
  import GridContainer from "$lib/molecules/GridContainer.svelte";
  import { onMount } from "svelte";
  import { BREAKPOINTS } from "$lib/utils/breakpoints";
  import GridItem from "$lib/atoms/GridItem.svelte";
  import BlogListItem from "$lib/molecules/BlogListItem.svelte";
  import Slider from "$lib/molecules/Slider.svelte";
  import ButtonLink from "$lib/atoms/ButtonLink.svelte";
  import { IconType } from "$types/atoms";
  import { lazyloadImg, textDir } from "$stores";

  export let blok: BlogListStoryblok;

  let desktopMediaQuery: MediaQueryList;
  let isMobile = false;

  onMount(() => {
    desktopMediaQuery = window.matchMedia(
      `(min-width: ${BREAKPOINTS.small}px)`,
    );
    desktopMediaQuery.addEventListener("change", onMediaQueryChange);

    onMediaQueryChange();
    return () => {
      desktopMediaQuery.removeEventListener("change", onMediaQueryChange);
    };
  });

  function onMediaQueryChange() {
    isMobile = !desktopMediaQuery.matches;
    setTimeout(() => {
      if ($lazyloadImg) {
        $lazyloadImg.update();
      }
    }, 0);
  }
</script>

<Section
  {blok}
  class="blog-list relative {blok?.extraClasses ?? ''} {$blogFilter?.filter
    ? 'blog-filtered'
    : ''}"
>
  <GridContainer>
    <GridItem col={12} colMd={9}>
      <div class="section-header" dir={$textDir}>
        {#if blok.eyebrow}
          <p class="eyebrow type:section-title">{blok.eyebrow}</p>
        {/if}
        {#if blok.headline}
          <h2 class="headline type:h2">{blok.headline}</h2>
        {/if}
      </div>
    </GridItem>
  </GridContainer>
  <GridContainer class="blog-grid" col={12}>
    {#if isMobile && blok.items}
      <GridItem col={12} style="display: none">
        <Slider
          items={blok.items}
          slidesPerView={blok.items.length > 1 ? 1.1 : 1}
          spaceBetween={blok.items.length > 1 ? 16 : 0}
          class="blog-list-slider"
        >
          <BlogListItem blok={item} slot="slide" let:prop={item} />
        </Slider>
      </GridItem>
    {:else if !isMobile && blok.items}
      {#each blok.items as item}
        <GridItem col={12}>
          <BlogListItem blok={item} />
        </GridItem>
      {/each}
    {/if}
    {#if blok.link && blok.link.length > 0}
      <GridItem col={12}>
        <div class="blog-cta">
          <ButtonLink blok={blok.link[0]} icon={IconType.ARROW_LINK} />
          <p class="type:label">{blok.extraLinkText}</p>
        </div>
      </GridItem>
    {/if}
  </GridContainer>
</Section>

<style lang="scss">
  :global(.blog-list) {
    overflow: hidden;
  }

  :global(.blog-filtered.hide-when-filtered) {
    display: none;
  }

  :global(.blog-grid .row) {
    @include breakpoint("small") {
      row-gap: 24px;
    }
  }

  .blog-cta {
    display: flex;
    align-items: center;
    column-gap: fluid(32px, 24px);
    margin-top: fluid(32px, 32px);

    p {
      display: none;
      @include breakpoint("small") {
        display: block;
        max-width: fluid(164px, 140px);
      }
    }
  }
</style>
